import moment from "moment/moment";

var _vm = null

import {formmasks} from './formmasks'
import {formrules} from './formrules'

const mercadoPago = {
  descricao: "Mercado Pago",
  img: "logoMercadoPago.jpg",
  weblink: "https://www.mercadopago.com.br",
  ios: {
    id: "925436649"
  },
  android: {
    host: "qr",
    scheme: "mercadopago",
    package: "com.mercadopago.wallet"
  }
}

export default {
  formmasks,
  formrules,
  // 
  mercadoPago,
  //
  formatBRL(number) {
    var formato = { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }
    return parseFloat(number).toLocaleString('pt-BR', formato);
  },

  formatCurrencyToBR(number) {
    return number ? (number.toFixed(2)).toLocaleString('pt-BR') : number;
  },
  formatCPF(cpf) {
    return cpf ? cpf
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4") : ''
  },
  formatCNPJ(cnpj) {
    if(cnpj) {
      const clean = cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      const values = clean.match(/([A-Z0-9]{0,2})([A-Z0-9]{0,3})([A-Z0-9]{0,3})([A-Z0-9]{0,4})([A-Z0-9]{0,2})/);
      cnpj = !values[2] ? values[1] : values[1] + '.' + values[2] + '.' + values[3] + '/' + values[4] + (values[5] ? '-' + values[5] : '');
      return cnpj;
    }
    return cnpj;
  },
  formatDateToBR(date, onlyDate) {
    if (!date) return null;
    return onlyDate 
      ? new Date(date+"T00:00:00").toLocaleDateString('pt-BR')
      : new Date(date).toLocaleString('pt-BR');
  },
  
  isMobile() {
    // aler(navigator.userAgent)
    return (/ANDROID|WEBOS|IPHONE|IPAD|IPOD|BLACKBERRY|IEMOBILE|OPERA MINI/i.test(navigator.userAgent.toUpperCase()))
  },
  isIosMobile() {
    // alert(navigator.userAgent)
    return (/IPHONE|IPAD|IPOD/i.test(navigator.userAgent.toUpperCase()))
  },
  link(name, params, query) {
    return new Promise(resolve => {
      var rota = {
        name: name
      }

      if (params != undefined)
        rota.params = params

      if (query != undefined)
        rota.query = query

      _vm.$router.push(rota)
      resolve()
    })
  },
  linkRedirect(url) {
    if (!url.includes('http')) {
      url = window.location.origin + '/' + url
    }

    window.location.href = url;
  },
  linkNewTab(url) {
    if (!url.includes('://')) {
      url = window.location.origin + '/' + url
    }
    if (this.isIosMobile()) {
      window.location.assign(url)
    } else {
      window.open(url, '_blank');
    }
  },
  removeAccents(str) {
    return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : str
  },
  checkIndex() {
    var fromIndex = !!(_vm.$route.redirectedFrom && _vm.$route.redirectedFrom.includes("index."))
    return fromIndex
  },
  isRoute(routename) {
    // console.log(_vm.$route)
    return (_vm.$route && _vm.$route.name == routename)
  },
  vue() {
    return _vm
  },
  round(n, places) {
    return +(Math.round(n + "e+" + places) + "e-" + places)
  },
  install(Vue, config) {
    _vm = config.vm
    Vue.prototype.$util = this
  },
  getImgByBenefitCode(benefitCode) {
    benefitCode = benefitCode ? benefitCode.toUpperCase() : benefitCode;
    switch (benefitCode) {
      case 'HEALTH':
        return {
          icon: 'fas fa-tooth',
          description: 'Odontológico'
        }
      case 'DENTAL':
        return {
          icon: 'fas fa-stethoscope',
          description: 'Saúde'
        }
      default:
        return '';
    }
  },
  getImgHeightByBenefitCode(benefitCode) {
    benefitCode = benefitCode ? benefitCode.toUpperCase() : benefitCode;
    switch (benefitCode) {
      case 'HEALTH':
        return 98;
      case 'DENTAL':
        return 157;
      default:
        return 100;
    }
  },
  removeMask(string) {
    if(string) {
      return string.replace(/[.\-/() ]/g, "");
    }
    return string;
  },
  formatDateFromBR(date) {
    return date ? moment(date).format('DD/MM/YYYY') : '';
  },
  base64ToBytesArray(stringBase64) {
    const sliceSize = 512;
    const byteCharacters = atob(stringBase64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return byteArrays;
  },
  acceptOnlyNumbers(evt){
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (evt.shiftKey || (charCode > 31 && (charCode < 37 || (charCode> 40 && charCode < 48) || (charCode > 57 && charCode < 96) || charCode > 105))){
      evt.preventDefault();
    } else {
      return true;
    }
  }
}
